import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { salesBreakdown: { getSalesBreakdown } } = apiUrls;

export const SALES_BREAKDOWN_SUCCESS = 'SALES_BREAKDOWN_SUCCESS';
export const SALES_BREAKDOWN_LOADING = 'SALES_BREAKDOWN_LOADING';

export const getSalesBreakdownData = ({ from, to, vendor }) => async (dispatch) => {

    try {
        if (vendor) {
            const requestData = {
                ...getSalesBreakdown,
                url: getSalesBreakdown.url.replace('{{vendor}}', vendor).replace('{from}', from).replace('{to}', to)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: SALES_BREAKDOWN_SUCCESS,
                data,
                vendor
            })
        }

    } catch (e) {

        dispatch({
            type: SALES_BREAKDOWN_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            },
            vendor
        })
    }

}

export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: SALES_BREAKDOWN_LOADING,
            isLoading,
            vendor
        });
    }
}